/**
 * Loading Component
 * 데이터 로딩 중 표시되는 공통 컴포넌트
 */
import React from "react";
import './Loading.css';

interface LoadingProps {
    message?: string;
    fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
    message = '로딩 중...',
    fullScreen = false
}) => {
    return (
        <div className={`loading-container ${fullScreen ? 'loading-fullscreen' : ''}`}>
            <div className="loading-content">
                <div className="loading-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                </div>
                <p className="loading-message">{message}</p>
            </div>
        </div>
    );
};

export default Loading;
